// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1O9kc","header":"ReportDetails_header__3n-8a","title":"ReportDetails_title__Ww4rE","left":"ReportDetails_left__yzKoA"};